<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="10">
                <el-card shadow="hover" class="mgb20">
                    <div class="user-info">
                        <img src="../../assets/img/img.jpg" class="user-avator" alt v-if="portrait==''"/>
						<el-image :src="portrait" class="user-avator" alt v-if="portrait!=''"/>
                        <div class="user-info-cont">
                            <div class="user-info-name">{{currentUserInfo.realName}}</div><br>
                            <div>{{currentUserInfo.roleName}}</div><br>
							<div>上次登录时间：<span>{{currentUserInfo.lastLoginTime}}</span></div>
                        </div>
                    </div>
                </el-card>
                <el-card shadow="hover" style="height:475px;">
					<!--<div slot="header" class="clearfix">
                        <span>系统提醒</span>
                        <router-link to="/my-todo-list"><el-button style="float: right; padding: 3px 0" type="text">更多</el-button></router-link>
                    </div>-->
					<el-tabs v-model="activeName" type="card" style="height:100%;">
						<el-tab-pane :label="`待办事项(${todoListSize})`" name="todoList" style="height:100%;">
							<el-table :show-header="false" :data="todoList" style="width:100%;" :cell-style="{padding:10+'px'}">
								<el-table-column prop="content" label="事项">
									<template slot-scope="scope">
										<font color="red" v-if = "new Date(scope.row.expirationTime).getTime() < new Date().getTime()">{{scope.row.content}}</font>
										<font color="#d58512" v-if = "new Date(scope.row.expirationTime).getTime() > new Date().getTime() && new Date(scope.row.expirationTime).getTime() - new Date().getTime() <  172800000">{{scope.row.content}}</font>
										<font color="black" v-if = "new Date(scope.row.expirationTime).getTime() - new Date().getTime() >  172800000">{{scope.row.content}}</font>
									</template>
								</el-table-column>
								<el-table-column prop="expirationTime" label="最晚处理时间" width="165"></el-table-column>
							</el-table>
							<router-link to="/my-todo-list"><el-button style="float: right; padding: 20px 32px 0px 0px" type="text" v-if="todoListSize>0">进入我的待办事项</el-button></router-link>
						</el-tab-pane>
						<el-tab-pane :label="`预警信息(${orderWarningSize})`" name="orderWarning" style="height:100%;">
							<el-table :show-header="false" :data="orderWarningList" style="width:100%;" :cell-style="{padding:10+'px'}">
								<el-table-column prop="warningInfo" label="预警信息">
									<template slot-scope="scope">
										[{{orderTypeFormat(null, null, scope.row.orderType)}}] {{scope.row.warningInfo}}
									</template>
								</el-table-column>
								<el-table-column prop="orderNo" label="订单号" width="130"></el-table-column>
							</el-table>
							<router-link to="/order-warning"><el-button style="float: right; padding: 20px 32px 0px 0px" type="text" v-if="orderWarningSize>0">查看全部订单预警</el-button></router-link>
						</el-tab-pane>
						<el-tab-pane :label="`追踪提醒(${toBeRemindedSize})`" name="trackInfo" style="height:100%;">
							<el-table :show-header="false" :data="toBeRemindedList" style="width:100%;" :cell-style="{padding:10+'px'}">
								<el-table-column prop="name" label="公司名称"></el-table-column>
								<el-table-column prop="latestContactTime" label="最近联系时间" width="130">
									<template slot-scope="scope">
										{{scope.row.latestContactTime?scope.row.latestContactTime:"--"}}
									</template></el-table-column>
							</el-table>
							<router-link :to="{path:'/chess-sect',query:{from:'track'}}"><el-button style="float: right; padding: 20px 32px 0px 0px" type="text" v-if="toBeRemindedSize>0">查看全部</el-button></router-link>
						</el-tab-pane>
						<el-tab-pane label="系统通知" name="notice" style="height:100%;">
							
						</el-tab-pane>
					</el-tabs>
                </el-card>
            </el-col>
            <el-col :span="14">
                <el-row :gutter="20" class="mgb20">
					<el-card shadow="hover" :body-style="{padding: '0px'}" style="margin-left:10px;margin-right:10px;margin-bottom:5px">
						<div class="grid-content grid-con-1">
							<i class="el-icon-lx-people grid-con-icon"></i>
							<div class="grid-cont-right">
								<div class="grid-num">{{customer.allCustomer}}</div>
								<div>总客户</div>
							</div>
							<div class="grid-cont-right">
								<div class="grid-num">{{customer.dealCustomer}}</div>
								<div>成交客户</div>
							</div>
							<div class="grid-cont-right">
								<div class="grid-num">{{customer.newCustomer}}</div>
								<div>当月新增客户</div>
							</div>
						</div>
					</el-card>
					<el-card shadow="hover" :body-style="{padding: '0px'}" style="margin-left:10px;margin-right:10px;margin-bottom:5px">
						<div class="grid-content grid-con-2">
							<i class="el-icon-lx-goods grid-con-icon"></i>
							<div class="grid-cont-right">
								<div class="grid-num">{{achievement.amountOfYear}}</div>
								<div>年销售额</div>
							</div>
							<div class="grid-cont-right">
								<div class="grid-num">{{achievement.amountOfMonth}}</div>
								<div>当月销售额</div>
							</div>
							<div class="grid-cont-right">
								<div class="grid-num">{{achievement.amountOfDay}}</div>
								<div>当日销售额</div>
							</div>
						</div>
					</el-card>
					<el-card shadow="hover" :body-style="{padding: '0px'}" style="margin-left:10px;margin-right:10px;">
						<div class="grid-content grid-con-3">
							<i class="el-icon-lx-notice grid-con-icon"></i>
							<div class="grid-cont-right">
								<div class="grid-num">{{achievement.amountOfPeriod}}</div>
								<div>账期货款</div>
							</div>
							<div class="grid-cont-right">
								<div class="grid-num">{{achievement.amountOfExpire}}</div>
								<div>快到期货款</div>
							</div>
							<div class="grid-cont-right">
								<div class="grid-num">{{achievement.amountOfOverDue}}</div>
								<div>逾期货款</div>
							</div>
						</div>
					</el-card>					
                </el-row>
                <el-card shadow="hover" style="height:340px;">
                    <div id="myChart" style="width: 100%; height:340px;"></div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { getControll } from '../../utils/controlls';
import { getUser, getUrgent, getCustomerNum, getOrderAmount, getPerformanceChartByTrackId, 
fetchOrderWarningData, fetchToBeRemindedChessSectData} from '../../api/index';
import bus from '../common/bus';
export default {
    name: 'dashboard',
    data() {
        return {
            currentUserInfo:{},
            todoList: [],
			orderWarningList:[],
			toBeRemindedList:[],
			customer: {},
			achievement: {},
            performanceOptions: {},
			activeName:"todoList",
			todoListSize:0,
			orderWarningSize:0,
			toBeRemindedSize:0,
			portrait:"",
			imgPrefix:"/image",
			controll:{}
        };
    },
	created() {
		this.controll = getControll("dashboard");
		this.getUserInfo();
		this.getUrgentInfo();
		this.getOrderWarningInfo();
		this.getToBeRemindedChessSectInfo();
		this.getCustomerTotal();
		this.getAchievement();
		bus.$on('todoListRefresh', msg => {
            this.getUrgentInfo();
        });
	},
    mounted() {
		this.getPerformance();
	},
    methods: {
		orderTypeFormat(row, column, cellValue) {
			let arrivalStatusConfig = {"0":"采购", "1":"销售"};
			return arrivalStatusConfig[cellValue];
		},
		getUserInfo() {
			this.$set(this.currentUserInfo, "realName", localStorage.getItem('ms_currentUserName'));
			this.$set(this.currentUserInfo, "roleName", localStorage.getItem('ms_currentRoleName'));
			this.$set(this.currentUserInfo, "lastLoginTime", localStorage.getItem('ms_currentLastLoginTime'));
			this.portrait=this.imgPrefix + localStorage.getItem('ms_currentPortrait');
		},
		getUrgentInfo() {
			getUrgent().then(res => {
				if (res.code == 0) {
					this.todoList = res.data.records;
					this.todoListSize = res.data.total;
				} else {
					this.$message.error("获取待办事项信息失败！" + res.message);
				}
			});
		},
		getOrderWarningInfo() {
			let condition = {};
			condition["pageSize"] = 8;
			fetchOrderWarningData(condition).then(res => {
				if (res.code == 0) {
					this.orderWarningList = res.data.records;
					this.orderWarningSize = res.data.total;
				} else {
					this.$message.error("获取订单预警信息失败！" + res.message);
				}
			});
		},
		getToBeRemindedChessSectInfo() {
			let condition = {};
			condition["pageSize"] = 8;
			fetchToBeRemindedChessSectData(condition).then(res => {
				if (res.code == 0) {
					this.toBeRemindedList = res.data.records;
					this.toBeRemindedSize = res.data.total;
				} else {
					this.$message.error("获取追踪信息失败！" + res.message);
				}
			});
		},
		getCustomerTotal() {
			getCustomerNum().then(res => {
				if (res.code == 0) {
					this.customer = res.data;
					if (this.customer.newCustomer == undefined) {
						this.customer['newCustomer'] = 0;
					}
				} else {
					this.$message.error("获取客户统计信息失败！" + res.message);
				}
			});
		},
		getAchievement() {
			getOrderAmount().then(res => {
				if (res.code == 0) {
					this.achievement = res.data;
				} else {
					this.$message.error("获取销售业绩信息失败！" + res.message);
				}
			});
		},
		getPerformance() {
			getPerformanceChartByTrackId().then(res => {
				if (res.code == 0) {
					this.performanceOptions = res.data.datasets;
					this.performanceOptions['title'] = this.performanceTitle;
					
					let option = {
						title: {
						  text: "最近6个月业绩",
						},
						tooltip: {
							trigger: 'axis'
						},
						grid: {
							left: '2%',
							right: '2%',
							bottom: '12%',
							containLabel: true
						},
						legend: {
							data: ["新增客户(人)", "销售业绩(万元)"],
						},
						yAxis: {},
						xAxis: {
							data : []
						},
						series: [],
					};
					option.series = res.data.datasets;
					option.xAxis["data"] = res.data.labels;
					let echarts = require("echarts");
			        let myChart = echarts.init(document.getElementById("myChart"));
					myChart.setOption(option);
				} else {
					this.$message.error("获取业绩信息失败！" + res.message);
				}
			});
		}

    }
};
</script>


<style scoped>
.el-row {
    margin-bottom: 20px;
}

.grid-content {
    display: flex;
    align-items: center;
    height: 100px;
}

.grid-cont-right {
    flex: 1;
    text-align: center;
    font-size: 14px;
    color: #999;
}

.grid-num {
    font-size: 22px;
    font-weight: bold;
}

.grid-con-icon {
    font-size: 50px;
    width: 100px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    color: #fff;
}

.grid-con-1 .grid-con-icon {
    background: rgb(45, 140, 240);
}

.grid-con-1 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-2 .grid-con-icon {
    background: rgb(242, 94, 67);
}

.grid-con-2 .grid-num {
    color: rgb(45, 140, 240);
}

.grid-con-3 .grid-con-icon {
    background: rgb(255, 153, 0);
}

.grid-con-3 .grid-num {
    color: rgb(255, 153, 0);
}

.user-info {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.user-avator {
    width: 120px;
    height: 120px;
    border-radius: 50%;
}

.user-info-cont {
    padding-left: 50px;
    flex: 1;
    font-size: 14px;
    color: #999;
}

.user-info-cont div:first-child {
    font-size: 30px;
    color: #222;
}

.user-info-list {
    font-size: 14px;
    color: #999;
    line-height: 25px;
}

.user-info-list span {
    margin-left: 70px;
}

.mgb20 {
    margin-bottom: 20px;
}

.todo-item {
    font-size: 14px;
}

.todo-item-del {
    text-decoration: line-through;
    color: #999;
}

.schart {
    width: 100%;
    height: 320px;
}
</style>
